import styled from 'styled-components';

export const BrandListingHeader = styled.div`
  padding: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #ccc;
`;

export const HeaderContainer = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: 12px;
`;

export const BrandMmtLogo = styled.img`
  height: 24px;
  width: 24px;
  margin-right: 4px;
`;

export const BrandMmtHeaderTitle = styled.span`
  font-size: 12px;
  font-weight: 700;
  font-family: 'Rubik';
`;

export const PostSalesContainer = styled.div`
  overflow-y: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
  position: relative;
  height: calc(100vh - 64px);
  background-color: #E7E7E7;
  font-family: 'Rubik';
  font-weight: 400;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const IncExcContainer = styled.div`
  &.height80 {
    min-height: 80%;
  }
`;